import React from 'react';
import './exchange-params.scss';
import { ArrowLeft, ArrowRight } from 'assets/icons';
import { getFormatDate } from 'utils/utils';
import { BlockchainTransactionInfo } from 'components';
import { useSelector } from 'hooks/redux';

export default function ExchangeParams() {
  const exchangeInfo = useSelector((s) => s.operationsSign.data.exchange);

  return (
    <div className="exchange-params">
      <p className="p p_bold p_color_grey mb_24">Параметры обмена</p>
      {exchangeInfo.blockchainTransactionId && (
        <div className="mb_24">
          <p className="p p_font-size_12 p_color_light-grey mb_4">
            {exchangeInfo.status === 'APPLIED'
              ? 'ID транзакции (зачисление)'
              : ' ID транзакции (резервирование)'}
          </p>
          <BlockchainTransactionInfo
            hash={exchangeInfo.blockchainTransactionId}
          />
        </div>
      )}
      <div className="exchange-params-info mb_24">
        <div className="exchange-params-info__header">
          <ArrowRight />
          <p className="p p_bold ml_10">Токен оферента</p>
        </div>
        <div className="exchange-params-info__body">
          <p className="p p_font-size_12 p_color_light-grey">
            Наименование токена:
          </p>
          <p className="p p_color_light-blue mb_12">
            {exchangeInfo.tokenNameFrom}
          </p>
          <p className="p p_font-size_12 p_color_light-grey">
            Количество токенов:
          </p>
          <p className="p p_color_grey">{exchangeInfo.tokenCountFrom}</p>
        </div>
      </div>
      <div className="exchange-params-info mb_24">
        <div className="exchange-params-info__header">
          <ArrowLeft />
          <p className="p p_bold ml_10">Токен адресата оферты</p>
        </div>
        <div className="exchange-params-info__body">
          <p className="p p_font-size_12 p_color_light-grey">
            Наименование токена:
          </p>
          <p className="p p_color_light-blue mb_12">
            {exchangeInfo.tokenNameTo}
          </p>
          <p className="p p_font-size_12 p_color_light-grey">
            Количество токенов:
          </p>
          <p className="p p_color_grey">{exchangeInfo.tokenCountTo}</p>
        </div>
      </div>
      <p className="p p_font-size_12 p_color_light-grey">Срок для акцепта</p>
      <p className="p p_color_grey">
        {getFormatDate(exchangeInfo.acceptDate, 'dd MMM yyyy', true)}
      </p>
    </div>
  );
}
